/**
 * Paths translationservice serves, kept apart from the request classes so they
 * can be asserted without pulling the whole service layer into a test.
 */

/** `GET` a product's languages with their translation counts recomputed. */
export const refreshProductLanguagesPath = ( productSlug: string ): string =>
  `/v1/product/${encodeURIComponent( productSlug )}/languages`;
